<template>
  <div
    class="alert-block"
    :class="type">
    <qx-spinner-inline
      v-if="isLoading"
      class="mr-2" />

    <em
      v-if="icon"
      :class="{
        'qx-icon icon-check-circle-o': type === 'success',
        'qx-icon icon-warning-diamond-o': type === 'warning',
        'qx-icon icon-info-circle-o': type === 'info',
        'qx-icon icon-cancel-circle-o': type === 'error',
      }" />
    <slot name="text">
      <span
        v-if="Array.isArray(text)"
        class="text">
        <span
          v-for="(item, index) in text"
          :key="index"
          class="d-inline-block"
          v-html="$sanitize(item)" />
      </span>
      <span
        v-else
        class="text"
        v-html="$sanitize(text)" />
    </slot>
  </div>
</template>

<script>
import QxSpinnerInline from '@/elements/QxSpinnerInline.vue';

export default {
  name: 'QxAlertBlock',
  components: { QxSpinnerInline },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => {
        return ['success', 'warning', 'info', 'error'].includes(value);
      },
    },
    text: {
      type: [String, Array],
      default: () => [],
    },
    icon: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
%icon {
  font-size: 25px;
  margin-right: 10px;
}
.icon-check-circle-o {
  @extend %icon;
  color: $base-green;
}
.icon-warning-diamond-o {
  @extend %icon;
  color: $base-orange;
}
.icon-info-circle-o {
  @extend %icon;
  color: $base-blue;
}
.icon-cancel-circle-o {
  @extend %icon;
  color: $red;
}

.alert-block {
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  width: 100%;
  padding: 14px;
  &.success {
    background-color: $g-10;
    border: 1px solid $g-25;
  }
  &.warning {
    background-color: $y-10;
    border: 1px solid $y-25;
  }
  &.info {
    background-color: $b-10;
    border: 1px solid $b-30;
  }
  &.error {
    background-color: $red-10;
    border: 1px solid $red-25;
  }
}

.text {
  display: flex;
  justify-content: center;
  flex-direction: column;
  // update fix for IE11
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
}
</style>
